import ApiService from '@/helpers/api.service';

const API = new ApiService();

// Endpoints
export const state = {
  agents: [],
  errors: null
}

export const mutations = {
  UPDATE_AGENT_LIST(state, agents){
    state.agents = agents;
  }
}

export const actions = {
  searchAgent(context, params){
    return new Promise((resolve, reject) => {
      API.post(`/agent/search`, params)
      .then(({data}) => {
        context.commit('UPDATE_AGENT_LIST', data.message.rows);
        resolve(data.message.rows);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  disableAgent(context, agentId){
    return new Promise((resolve, reject) => {
      API.post(`/agent/deactivate`, { agent_id: agentId })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  createAgent(context, agentDetails){
    return new Promise((resolve, reject) => {
      API.post(`/agent/create`, agentDetails)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  isExist(context, agentCode){
    return new Promise((resolve, reject) => {
      API.post(`/agent/is-exist`, { agentCode: agentCode})
      .then(({data}) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }
}

export const getters = {}